/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class UnionAPI
 * @hideconstructor
 * @classdesc Provides access to the the union object associated to this dataitem.
 */
define([], () => {
	let idCounter = 0;
	let lastIdDate = (new Date()).valueOf();
	return class UniqueId {
		static generate(prefix) {
			var date = (new Date()).valueOf();
			if (date !== lastIdDate) {
				idCounter = 0;
				lastIdDate = date;
			} else {
				idCounter++;
			}

			var datePart = ('0000000000000000' + date.toString(16)).slice(-16);
			var countPart = ('00000000' + idCounter.toString(16)).slice(-8);

			return [prefix, datePart, '_', countPart].join('');
		}
	};
});
